import {saveAudioVolume, loadAudioVolume} from "./includes/audio-helpers";
import { InitBackgroundGeometry } from "./includes/tau-sacred-geometry.js";

let userInteracted = false;

function lerp(start, end, progress) {
    return start + (end - start) * progress;
}
function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
}
function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
}
function easeInCubic(x) {
    return x * x * x;
}

// Index page animated logo
const TauLogo = document.querySelector('.TauLogo');
if (TauLogo) {
    const TauLogoAccent = TauLogo.querySelector('.TauLogo-accent');
    const TauLogoOverlay = TauLogo.querySelector('.TauLogo-overlay');

    const ANIMATION_CYCLE = 250;
    const ANIMATION_DURATION = ANIMATION_CYCLE * 2;
    const timestamp = Date.now();
    let animationStart;
    function startLogoAnimation() {
        animationStart = Date.now();
        TauLogoAccent.classList.add('is-active');
        requestAnimationFrame(logoAnimationFrame);
    }
    function logoAnimationFrame() {
        const elapsed = Date.now() - animationStart;
        const progress = (elapsed % ANIMATION_CYCLE) / ANIMATION_CYCLE;
        //const y = -100 + 300 * progress;
        const start = -50 + 150 * progress;
        const mid = start + 25;
        const end = start + 50;
        const alpha = Math.sin(progress * Math.PI);


        TauLogoOverlay.style.maskImage = `linear-gradient(to bottom, transparent ${start}%, black ${mid}%, transparent ${end}%)`;
        TauLogoOverlay.style.filter = `opacity(${alpha})`;

        if (elapsed < ANIMATION_DURATION) {
            requestAnimationFrame(logoAnimationFrame);
        }
    }

    window.addEventListener('load', () => {
        const elapsed = Date.now() - timestamp;
        if (elapsed < 1000) {
            setTimeout(startLogoAnimation, 1000 - elapsed);
        } else {
            startLogoAnimation();
        }
    });
}

// Index page mouse-motion parallax
const MastheadElement = document.getElementById("masthead");
const ParallaxRoot = document.querySelector('.MastheadBackground');
if (ParallaxRoot) {
    const ParallaxBase = ParallaxRoot.querySelector('.MastheadBackground-base');
    const KeyDeltaFactor = -0.2;
    const DriftIngressTime = 1000;
    const DriftPauseTime = 2500;
    const DriftDecayTime = 5000;
    const DriftResumeTime = DriftPauseTime + DriftDecayTime;
    const MotionScaleFactor = 5.0;
    let syncFactor = 0;
    let mouseX, mouseY;
    let lastMouseEvent = 0;
    let frameTimestamp = 0;

    function calcDriftFactor() {
        const ms = Date.now() % 30000;
        const progress = ms / 30000.0;
        const rad = progress * 2 * Math.PI;
        const driftX = Math.cos(rad);
        const driftY = Math.sin(rad) * 0.5625;

        return {driftX, driftY}
    }

    function sync(timestamp) {
        if (frameTimestamp < timestamp) {
            const elapsed = timestamp - frameTimestamp;
            frameTimestamp = timestamp;

            if (window.PageComponents && window.PageComponents.isDesktopUp()) {
                const timeSinceLastMouseEvent = Date.now() - lastMouseEvent;

                let deltaX = 0;
                let deltaY = 0;
                const {driftX, driftY} = calcDriftFactor();
                if (timeSinceLastMouseEvent < DriftResumeTime) {
                    const mouseMax = MastheadElement.getBoundingClientRect().width / 2;
                    if (timeSinceLastMouseEvent > DriftPauseTime) {
                        syncFactor = 1.0 - (timeSinceLastMouseEvent - DriftPauseTime) / DriftDecayTime;
                    } else {
                        if (syncFactor < 1.0) {
                            syncFactor += (elapsed / DriftIngressTime);
                            if (syncFactor > 1.0) syncFactor = 1.0;
                        }
                    }
                    deltaX = lerp(driftX, (mouseX / mouseMax), easeInOutSine(syncFactor));
                    deltaY = lerp(driftY, (mouseY / mouseMax), easeInOutSine(syncFactor));
                } else {
                    deltaX = driftX;
                    deltaY = driftY;
                }

                deltaX *= MotionScaleFactor;
                deltaY *= MotionScaleFactor;

                ParallaxBase.style.transform = `translate(${-50 + KeyDeltaFactor * deltaX}%, ${-50 + KeyDeltaFactor * deltaY}%)`;
            } else {
                ParallaxBase.style.transform = null;
            }

            update();
        }
    }

    function update() {
        requestAnimationFrame(sync);
    }

    function syncMouse(e) {
        const rect = MastheadElement.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.width * .28125;
        mouseX = e.clientX - centerX;
        mouseY = e.clientY - centerY;
        lastMouseEvent = Date.now();
    }
    MastheadElement.addEventListener("mousemove", syncMouse);

    document.addEventListener('DOMContentLoaded', update);
}

// Intro animation
const KEY_INTRO_VIEWED = "kTauIntroViewed";
const IntroRoot = document.querySelector('.TauIntro');
if (IntroRoot) {
    // todo: skip on subsequent loads?
    const TauIntroButton = document.querySelector('.TauIntroButton');
    const TauMuteButton = document.querySelector('.TauMuteButton');
    const TauVolumePips = TauMuteButton && TauMuteButton.querySelectorAll('.TauMuteButton-pip');
    const IntroMote = IntroRoot.querySelector('img.TauIntro-mote');
    const IntroAudio = IntroRoot.querySelector('audio.TauIntro-audio');
    const IntroCanvas = IntroRoot.querySelector('canvas.TauIntro-canvas');
    const IntroAnchor = IntroRoot.querySelector('.TauIntro-anchor');
    const IntroEnterButton = IntroRoot.querySelector('#intro-button');

    const CanvasContext = IntroCanvas.getContext("2d");
    const BufferCanvas = document.createElement("canvas");
    BufferCanvas.width = IntroCanvas.width;
    BufferCanvas.height = IntroCanvas.height;
    const BufferContext = BufferCanvas.getContext("2d");

    const BackgroundDeltaFactor = -0.1;
    const DriftIngressTime = 1000;
    const DriftPauseTime = 2500;
    const DriftDecayTime = 5000;
    const DriftResumeTime = DriftPauseTime + DriftDecayTime;
    const MotionScaleFactor = 5.0;
    let syncFactor = 0;
    let mouseX, mouseY;
    let hoveringAnchor = false;
    let loadComplete = 0;
    let lastMouseEvent = 0;
    let previousFrame = 0;
    let animationEnabled = true;
    let audioMuted = true;

    function introDriftFactor() {
        const ms = Date.now() % 30000;
        const progress = ms / 30000.0;
        const rad = progress * 2 * Math.PI;
        const driftX = Math.cos(rad);
        const driftY = Math.sin(rad) * 0.5625;

        return {driftX, driftY}
    }

    const Motes = [];
    let nextMoteSpawn = 0;
    function doStaticAnimation(elapsed) {
        CanvasContext.clearRect(0, 0, IntroCanvas.width, IntroCanvas.height);
        CanvasContext.drawImage(BufferCanvas, 0, 0);

        BufferContext.clearRect(0, 0, BufferCanvas.width, BufferCanvas.height);
        if (Motes.length > 0) {
            let mote;
            let x, y, rawProgress, progress, size;
            for (let i = Motes.length - 1; i > -1; i--) {
                mote = Motes[i];

                if (mote.end < elapsed) {
                    Motes.splice(i, 1);
                    continue;
                }

                rawProgress = (elapsed - mote.start) / mote.duration;
                progress = easeOutQuad(rawProgress);
                x = lerp(mote.startX, mote.endX, progress);
                y = lerp(mote.startY, mote.endY, progress);
                if (mote.arcX) {
                    x += mote.arcDistance * mote.arcX * Math.sin(Math.PI * progress);
                }
                if (mote.arcY) {
                    y += mote.arcDistance * mote.arcY * Math.sin(Math.PI * progress);
                }
                size = mote.size * (0.5 + 0.5 * (1.0 - progress));
                x -= size / 2;
                y -= size / 2;
                BufferContext.globalAlpha = mote.opacity * Math.sin(Math.PI * rawProgress);
                BufferContext.drawImage(
                    IntroMote,
                    x,
                    y,
                    size,
                    size
                );
            }
        }
        if (nextMoteSpawn <= elapsed && Motes.length < 500) {
            addMote(elapsed);
            if (hoveringAnchor) {
                nextMoteSpawn = elapsed + 100 + Math.round(Math.random() * 50);
            } else {
                nextMoteSpawn = elapsed + 300 + Math.round(Math.random() * 200);
            }
        }
        function addMote(time) {
            const durationRoll = Math.random();
            const duration = Math.round(4000 + durationRoll * 6000);
            const driftFactorX = -1 + Math.random() * 2;
            const driftFactorY = -1 + Math.random() * 2;
            const startX = 1320 + (driftFactorX * 10);
            const startY = 300 + (driftFactorY * 10);
            const endX = Math.round(startX - 300 + driftFactorX * 1000);
            const endY = Math.round(startY - 200 + driftFactorY * 600);
            const arcX = -1 + Math.random() * 2;
            const arcY = -1 + Math.random() * 2;
            const arcDistance = 200 - durationRoll * 100;
            // size is inversely proportional to duration (bigger motes faster)
            const size = hoveringAnchor ? 75 + Math.round((1 - durationRoll) * 125)
                : 50 + Math.round((1 - durationRoll) * 50);
            const opacity = 0.5 + durationRoll * 0.5;
            Motes.push({
                start: time,
                end: time + duration,
                duration,
                startX,
                startY,
                endX,
                endY,
                arcX,
                arcY,
                arcDistance,
                size,
                opacity,
            });
        }
    }

    function syncIntro(currentFrame) {
        if (previousFrame < currentFrame) {
            const elapsed = currentFrame - previousFrame;
            previousFrame = currentFrame;

            const now = Date.now();
            const loadElapsed = now - loadComplete;
            doStaticAnimation(loadElapsed);

            // Only do background shift at tablet+
            if (!window.PageComponents || window.PageComponents.isTabletUp()) {
                const timeSinceLastMouseEvent = now - lastMouseEvent;

                let deltaX = 0;
                let deltaY = 0;
                const {driftX, driftY} = introDriftFactor();
                if (timeSinceLastMouseEvent < DriftResumeTime) {
                    const mouseMax = MastheadElement.getBoundingClientRect().width / 2;
                    if (timeSinceLastMouseEvent > DriftPauseTime) {
                        syncFactor = 1.0 - (timeSinceLastMouseEvent - DriftPauseTime) / DriftDecayTime;
                    } else {
                        if (syncFactor < 1.0) {
                            syncFactor += (elapsed / DriftIngressTime);
                            if (syncFactor > 1.0) syncFactor = 1.0;
                        }
                    }
                    deltaX = lerp(driftX, (mouseX / mouseMax), easeInOutSine(syncFactor));
                    deltaY = lerp(driftY, (mouseY / mouseMax), easeInOutSine(syncFactor));
                } else {
                    deltaX = driftX;
                    deltaY = driftY;
                }

                deltaX *= MotionScaleFactor;
                deltaY *= MotionScaleFactor;

                IntroRoot.style.setProperty('--intro-background-transform', `translate(${-50 + BackgroundDeltaFactor * deltaX}%, ${-50 + BackgroundDeltaFactor * deltaY}%)`);
                IntroRoot.style.setProperty('--intro-foreground-transform', `translate(${-50 - BackgroundDeltaFactor * deltaX}%, ${-50 - BackgroundDeltaFactor * deltaY}%)`);
            }

        }
        if (animationEnabled) requestAnimationFrame(syncIntro);
    }

    let lastX = -1;
    let lastY = -1;
    function syncMouse(e) {
        const rect = IntroRoot.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.width * .28125;
        mouseX = e.clientX - centerX;
        mouseY = e.clientY - centerY;
        lastMouseEvent = Date.now();
        if (animationEnabled) {
            const canvasRect = IntroCanvas.getBoundingClientRect();
            const canvasX = e.clientX - canvasRect.left;
            const canvasY = e.clientY - canvasRect.top;
            lastX = canvasX;
            lastY = canvasY;
        }
    }

    function anchorMouseOver() {
        IntroRoot.classList.add('is-hover');
        hoveringAnchor = true;
    }
    function anchorMouseOut() {
        IntroRoot.classList.remove('is-hover');
        hoveringAnchor = false;
    }

    function syncMuteButton() {
        TauMuteButton.classList.toggle('is-muted', audioMuted);
    }
    function syncVolumePips(level) {
        IntroAudio.volume = level;
        if (TauVolumePips) {
            TauVolumePips.forEach((pip, index) => {
               const l = index / 10;
               pip.style.setProperty('--volume-active', l < level ? '0.5' : null);
            });
        }
    }
    function audioEndHandler() {
        IntroAudio.currentTime = 0;
        audioMuted = true;
        syncMuteButton();
    }
    function muteHandler() {
        if (audioMuted) {
            if (IntroAudio.paused) {
                try {
                    IntroAudio.play();
                    audioMuted = false;
                } catch (e) {
                    // do nothing;
                }
            }
        } else {
            if (!IntroAudio.paused) {
                try {
                    IntroAudio.pause();
                    audioMuted = true;
                } catch (e) {
                    // do nothing;
                }
            }
        }
        syncMuteButton();
    }

    let introEventsInitialized = false;
    function startIntro() {
        if (window.Warframe && window.Warframe.lockPageScrolling) window.Warframe.lockPageScrolling();
        IntroRoot.setAttribute('data-state', '1');
        setTimeout(
            () => {
                mouseX = mouseY = lastX = lastY = 0;
                lastMouseEvent = Date.now();
                animationEnabled = true;
                requestAnimationFrame(syncIntro);
            },
            1000
        );
        setTimeout(
            () => {
                if (!introEventsInitialized) {
                    IntroAnchor.addEventListener('mouseover', anchorMouseOver);
                    IntroAnchor.addEventListener('mouseout', anchorMouseOut);
                    IntroAnchor.addEventListener('click', endIntro);
                    IntroEnterButton.addEventListener('mouseover', anchorMouseOver);
                    IntroEnterButton.addEventListener('mouseout', anchorMouseOut);
                    IntroEnterButton.addEventListener('click', endIntro);
                    IntroRoot.addEventListener("mousemove", syncMouse);

                    introEventsInitialized = true;
                }

                IntroRoot.setAttribute('data-state', '2');
            },
            3000
        );
    }

    function endIntro(event) {
        event.preventDefault();
        event.stopPropagation();

        userInteracted = true;

        anchorMouseOut();
        IntroRoot.setAttribute('data-state', '3');
        if (window.Warframe && window.Warframe.unlockPageScrolling) window.Warframe.unlockPageScrolling();

        try {
            syncVolumePips(loadAudioVolume());
            IntroAudio.play();
            audioMuted = false;
            syncMuteButton();
        } catch (e) {
            // do nothing
        }

        setTimeout(
            () => {
                IntroRoot.setAttribute('data-state', '4');
                animationEnabled = false;
            },
            2000
        );

        if (localStorage) {
            localStorage.setItem(KEY_INTRO_VIEWED, 'true');
        }
    }

    function skipIntro() {
        IntroRoot.setAttribute('data-state', '4');
        animationEnabled = false;
        if (window.Warframe && window.Warframe.unlockPageScrolling) window.Warframe.unlockPageScrolling();
        syncVolumePips(loadAudioVolume());
        audioMuted = true;
        syncMuteButton();
    }

    const LoadDelay = 1000;
    const LoadStart = Date.now();
    if (window.Warframe && window.Warframe.lockPageScrolling) window.Warframe.lockPageScrolling();
    function loadHandler() {
        loadComplete = Date.now();

        try {
            if (localStorage && localStorage.getItem(KEY_INTRO_VIEWED) === 'true') {
                skipIntro();
                return;
            }
        } catch (ex) {
            // do nothing
        }

        const elapsed = loadComplete - LoadStart;
        // Delay to pad out intro startup
        if (elapsed < LoadDelay) {
            setTimeout(() => {
                loadComplete = Date.now();
                startIntro();
            }, LoadDelay - elapsed);
        }
        // Immediate start
        else {
            startIntro();
        }
    }

    if (IntroAudio) {
        IntroAudio.addEventListener('ended', audioEndHandler);
    }
    if (TauIntroButton) {
        TauIntroButton.addEventListener('click', startIntro);
    }
    if (TauMuteButton) {
        TauMuteButton.addEventListener('click', muteHandler);
    }
    if (TauVolumePips) {
        TauVolumePips.forEach((pip, index) => {
            const level = (index + 1) / 10;
            pip.addEventListener('click', (e) => {
                e.stopPropagation();
                syncVolumePips(level);
                if (audioMuted) {
                    muteHandler();
                }
                saveAudioVolume(level);
            });
        });
    }

    window.addEventListener('load', loadHandler);
}

// Intro page carousel sync
function initCarousels() {
    const IntroCarouselTextContainers = document.querySelectorAll('.TauCarouselContent-text');
    if (IntroCarouselTextContainers && IntroCarouselTextContainers.length > 0) {
        IntroCarouselTextContainers.forEach((container) => {
            if (container.dataset.carousel) {
                const IntroCarouselTexts = container.querySelectorAll('.TauCarouselContentText');
                if (IntroCarouselTexts && IntroCarouselTexts.length > 0) {
                    const carousel = window.PageComponents.Carousel.instances[container.dataset.carousel];
                    if (carousel) {
                        carousel.beforeChange(({oldSlide, newSlide}) => {
                            oldSlide.classList.remove('is-faded');
                            newSlide.classList.add('is-faded');
                            IntroCarouselTexts.forEach((text) => {
                                text.classList.toggle('is-active', text.dataset.index === newSlide.dataset.index);
                            })
                        });
                    } else {
                        console.error("Unable to find target carousel: " + carousel);
                    }
                }
            }
        });
    }
}
window.addEventListener('PageComponentsLoaded', initCarousels);

// Sacred geometry backgrounds
const SacredGeometryBackgrounds = document.querySelectorAll('[data-sacred-geometry]' );
if ( SacredGeometryBackgrounds && SacredGeometryBackgrounds.length > 0 ) {
    SacredGeometryBackgrounds.forEach( InitBackgroundGeometry );
}

document.addEventListener('click', () => {
    userInteracted = true;
});
